export default __webpack_public_path__ + "static/media/Guinness_Pint.d0f0bbe0.png";